import React, { createContext, useState, useEffect } from "react";
import enTranslations from "../locales/en.json";
import frTranslations from "../locales/fr.json";

export const TranslationContext = createContext();

const TranslationProvider = ({ children }) => {
  const defaultLang = localStorage.getItem("selectedLanguage") || "fr";
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLang);
  const [translations, setTranslations] = useState(frTranslations);

  const routes = {
    en: {
      home: "/home",
      login: "/login",
      register: "/register",
      success: "/success",
      subscription: "/premium-badge",
      legalNotices: "/legal-notices",
      myWallet: "/my-wallet",
      chatroom: "/chatroom",
      sendMessages: "/send-my-opinions",
    },
    fr: {
      home: "/accueil",
      login: "/se-connecter",
      register: "/enregistrer",
      success: "/congratulation",
      subscription: "/badge-premium",
      legalNotices: "/cgu",
      myWallet: "/my-email-(donations)",
      chatroom: "/chatroom",
      sendMessages: "/vidéo-pertinente-(Brief)",
    },
  };

  useEffect(() => {
    const languageMap = {
      en: enTranslations,
      fr: frTranslations,
    };
    setTranslations(languageMap[selectedLanguage] || frTranslations);
    localStorage.setItem("selectedLanguage", selectedLanguage);
  }, [selectedLanguage]);

  return (
    <TranslationContext.Provider
      value={{ translations, selectedLanguage, setSelectedLanguage, routes: routes[selectedLanguage] }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

export default TranslationProvider;
